import { CUSTOM_ELEMENTS_SCHEMA, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

// NOVOS COMPONENTES
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicStorageModule } from '@ionic/storage-angular';

// CONFIGURAÇÃO
import { PasswordStrengthMeterModule } from 'angular-password-strength-meter';
import { DashBoardService } from 'src/providers/apiservices/dashboardservices';
import { GlobalService } from 'src/providers/apiservices/globalservices';
import { APIService } from '../providers/apiservices/apiservices';
import { ConfigProvider } from '../providers/config/config';
import { ShowModalService } from 'src/providers/apiservices/showmodalservice';




// PROVIDERS ECINE
import { AuditoriaProvider } from '../providers/auditoria/auditoria';
import { AuthProvider } from '../providers/auth/auth';
import { TokensProvider } from '../providers/tokens/tokens';
import { UsuariosProvider } from '../providers/usuarios/usuarios';
import { ValidacaoProvider } from '../providers/usuarios/validacao';
//import { VideosEnviadosProvider } from '../providers/videosenviados/videosenviados';
import { AuthChatProvider } from '../providers/auth/autchat';
import { FaqProvider } from '../providers/faq/faq';

import { PusherServiceProvider } from 'src/providers/pusher/pusher-service.service';
import { MessagePage } from './components-modal/message/message.page';
import { TokensPage } from './components-modal/tokens/tokens.page';

import { registerLocaleData } from '@angular/common';
import localeBr from '@angular/common/locales/pt';
import { QuillModule } from 'ngx-quill';
import { LocalStorageService } from 'ngx-webstorage';
import { LocalStorageProvider } from 'src/providers/apiservices/localstorageprovider';
import { RolesInterceptor } from 'src/providers/apiservices/rolesInterceptor';
import { AutorizacaoServicoProvider } from 'src/providers/autorizacaoservico/autorizacaoservico';
import { BibliotecaProvider } from 'src/providers/biblioteca/biblioteca';
import { BoletosCobrancaProvider } from 'src/providers/boletoscobranca/boletoscobranca';
import { ComunicacaoProvider } from 'src/providers/comunicacao/comunicacao';
import { ContratoProvider } from 'src/providers/contrato/contrato';
import { DashboardMultiProvider } from 'src/providers/dashboardmulti/dashboardmulti';
import { DepartamentosProvider } from 'src/providers/departamentos/departamentos';
import { EmpresaProvider } from 'src/providers/empresa/empresa';
import { InformeVendasProvider } from 'src/providers/informevendas/informevendas';
import { ModuloProvider } from 'src/providers/modulo/modulo';
import { NotificacoesProvider } from 'src/providers/notificacoes/notificacoes';
import { OrigemProvider } from 'src/providers/origem/origem';
import { PerfilProvider } from 'src/providers/perfil/perfil';
import { SegmentoProvider } from 'src/providers/segmento/contrato';
import { ServicosProvider } from 'src/providers/servicos/servicos';
import { TarefasProvider } from 'src/providers/tarefas/tarefas';
import { UsuarioMultiplanProvider } from 'src/providers/usuarios/usuariomultiplan';
import { MessageComunicacaoPage } from './components-modal/message-comunicacao/message-comunicacao.page';
import { MessageInformePage } from './components-modal/message-informe/message-informe.page';
import { OnlyNumberDirective } from './directives/onlyNumber';

import { ControleService } from "../providers/controleciente/controle.service";
import { ControleCienteProvider } from "../providers/controleciente/controleciente";
import { ControleCientePage } from "./components-modal/controleciente/controleciente.page";
import { DestinatariosAuditoriaComponent } from './components-modal/message-comunicacao/destinatarios-auditoria/destinatarios-auditoria.component';
import {NgxPrintModule} from 'ngx-print';
import {IacomunicacaoProvider} from "../providers/iacomunicacao/iacomunicacao";
import {OrigemService} from "../providers/origemservice/origem.service";
import { PrestacaoProvider } from 'src/providers/prestacao/prestacao';
import { ModalsProvider } from 'src/providers/modals/modals';
import { FormBeneficiosProvider } from 'src/providers/formbeneficios/formbeneficios';
import { BannersProvider } from 'src/providers/banners/banners';

registerLocaleData(localeBr, 'pt')

@NgModule({
  declarations: [AppComponent,TokensPage, MessagePage, MessageComunicacaoPage, MessageInformePage, ControleCientePage, DestinatariosAuditoriaComponent],
  entryComponents: [TokensPage, MessagePage, MessageComunicacaoPage, MessageInformePage, ControleCientePage, DestinatariosAuditoriaComponent],
  imports: [
    BrowserModule,
    IonicModule.forRoot({
      mode: 'md'
    }),
    AppRoutingModule,
    HttpClientModule,
    IonicStorageModule.forRoot(),
    FormsModule,
    ReactiveFormsModule,
    PasswordStrengthMeterModule.forRoot(),
    QuillModule.forRoot(),
    NgxPrintModule
  ],
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: HTTP_INTERCEPTORS, useClass: RolesInterceptor, multi: true },
    { provide: LOCALE_ID, useValue: 'pt' },
    ControleService,
    LocalStorageService,
    ConfigProvider,
    APIService,
    ShowModalService,
    GlobalService,
    DashBoardService,
    OrigemService,
    AuthProvider,
    TokensProvider,
    UsuariosProvider,
    AuditoriaProvider,
    ValidacaoProvider,
    AuthChatProvider,
    FaqProvider,
    PusherServiceProvider,
    PerfilProvider,
    ModuloProvider,
    EmpresaProvider,
    FormBeneficiosProvider,
    BoletosCobrancaProvider,
    BibliotecaProvider,
    PrestacaoProvider,
    IacomunicacaoProvider,
    NotificacoesProvider,
    ContratoProvider,
    TarefasProvider,
    DepartamentosProvider,
    DashboardMultiProvider,
    ServicosProvider,
    SegmentoProvider,
    ControleCienteProvider,
    OrigemProvider,
    UsuarioMultiplanProvider,
    ComunicacaoProvider,
    AutorizacaoServicoProvider,
    LocalStorageProvider,
    InformeVendasProvider,
    OnlyNumberDirective,
    ModalsProvider,
    BannersProvider
  ],
  bootstrap: [AppComponent],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class AppModule {}
